import { get } from 'lodash';
import { FREE_PROTECTION_DEDUCTION } from '../../constants';
import { FORM, POINT_TYPE, SHIPMENT } from '../../../../constants';
import { DateUtil } from '../../../../utils';
import { NetworkHelpers, ShipmentHelpers } from '../../../../helpers';
import { SECTION_FIELDS_MAP } from './constants';

export const getFieldsToUpdate = ({ network, values }) => {
  const isLiabilityValueAvailable =
    network.insurance && !get(values, FORM.SHIPMENT_FIELDS.LIABILITY_VALUE.KEY);

  return {
    [FORM.SHIPMENT_FIELDS.NETWORK.KEY]: network,
    [FORM.SHIPMENT_FIELDS.LIABILITY.KEY]: network.insurance,
    ...(isLiabilityValueAvailable && {
      [FORM.SHIPMENT_FIELDS.LIABILITY_VALUE.KEY]: FREE_PROTECTION_DEDUCTION,
    }),
  };
};

export const resetSectionsFields = (form, sections) => {
  sections.forEach(section => {
    const fields = SECTION_FIELDS_MAP[section].map(({ name }) => name);

    fields.forEach(field => {
      form.change(field, undefined);
    });
  });
};

export const getAvailableNetworks = (networks, values) => {
  let filteredNetworks = networks;
  const parcels = get(values, FORM.SHIPMENT_FIELDS.PARCELS.KEY);
  const collectFrom = get(values, FORM.SHIPMENT_FIELDS.COLLECT_FROM.KEY);
  const deliveryTo = get(values, FORM.SHIPMENT_FIELDS.DELIVER_TO.KEY);

  const shipmentDate = get(values, FORM.SHIPMENT_FIELDS.SHIPMENT_DATE.KEY);
  // Only show Sat or Sun options if the selected collection date is Fri or Sat
  if (
    !DateUtil.isFriOrSat(new Date(shipmentDate)) ||
    collectFrom == POINT_TYPE.SHOP
  ) {
    filteredNetworks = networks.filter(
      ({ networkKey }) => !SHIPMENT.WEEKEND_NETWORKS.includes(networkKey)
    );
  }

  if (deliveryTo === POINT_TYPE.SHOP) {
    filteredNetworks = filteredNetworks.filter(({ networkDetails }) =>
      ShipmentHelpers.isFlagOptional(networkDetails, 'shipToPickup')
    );
  } else {
    filteredNetworks = filteredNetworks.filter(({ networkDetails }) =>
      collectFrom === POINT_TYPE.SHOP
        ? !networkDetails?.premium &&
          !ShipmentHelpers.isFlagOptional(networkDetails, 'shipToPickup')
        : !ShipmentHelpers.isFlagOptional(networkDetails, 'shipToPickup')
    );
  }

  return NetworkHelpers.sortNetworksByPrice(filteredNetworks, parcels);
};
